import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./AdminLogin.css";

const API_URL = process.env.REACT_APP_API_URL;

function AdminLogin(){


const navigate = useNavigate();

const [email,setEmail] = useState("");
const [password,setPassword] = useState("");
const [showPassword, setShowPassword] = useState(false);

const handleLogin = async (e)=>{

e.preventDefault();

try{

    const res = await axios.post(`${API_URL}/auth/login`,{
      email: email.trim().toLowerCase(),
      password: password.trim()
    });

if(res.data.user.role !== "admin"){
toast.error("Access denied. Not an admin");
return;
}

localStorage.setItem("token",res.data.token);

toast.success("Login successful");

setTimeout(()=>{
navigate("/admin/dashboard",{replace:true});
},1000);

}catch(err){
const errorMessage = err.response?.data?.message || "Invalid email or password";
toast.error(errorMessage);

}

};

return(

<div className="admin-login-container">

<div className="admin-login-box">

<h2>Admin Login</h2>

<form onSubmit={handleLogin}>

<input
type="email"
name="email"
placeholder="Email"
value={email}
onChange={(e)=>setEmail(e.target.value)}
autoCapitalize="none"
autoCorrect="off"
spellCheck="false"
required
/>

<div style={{ position: 'relative', width: '100%' }}>
<input
type={showPassword ? "text" : "password"}
name="password"
placeholder="Password"
value={password}
onChange={(e)=>setPassword(e.target.value)}
autoCapitalize="none"
autoCorrect="off"
spellCheck="false"
required
style={{ paddingRight: '40px', marginBottom: '15px' }}
/>
<i 
className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
onClick={() => setShowPassword(!showPassword)}
style={{ position: 'absolute', right: '12px', top: '21px', transform: 'translateY(-50%)', cursor: 'pointer', color: '#666', fontSize: '18px' }}
></i>
</div>

<button type="submit">
Login
</button>

</form>

</div>

</div>

);

}

export default AdminLogin;
